export default function LijnTab({ xl }) {
  const { Table, avg, euro, kgf, pct, safeDiv, sum, toNum, lines, rows, showCosts } = xl;
  return (
          <>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900 mb-1">Lijnanalyse</h1>
            <p className="text-sm text-slate-500 mb-6">Prestatie per productielijn.</p>
            <Table hideCols={showCosts ? [] : [2, 3]} columns={["Lijn", "Geproduceerd", "Totale kosten", "Kostprijs/kg", "OEE", "Stilstand uren"]}
              rows={lines.map((l) => { const f = rows.filter((r) => r.lijn === l.naam); const g = sum(f, (r) => r.geproduceerdKg); const k = sum(f, (r) => r.totaleKosten); return [l.naam, kgf(g), euro(k), euro(safeDiv(k, g)), pct(avg(f, (r) => r.oee)), sum(f, (r) => toNum(r.stillstandUren)).toFixed(1)]; })} />
          </>
  );
}
